import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';

import Home from './pages/Home';
import About from './pages/About';
import { Services, Mining, Diamonds, Renewables, EcoTourism } from './pages/SectorPages';
import { AfricaOps, Projects, Team, Partners } from './pages/OtherPages1';
import { News, Gallery, Careers, Contact } from './pages/OtherPages2';

const PAGES = {
  home: Home,
  about: About,
  services: Services,
  mining: Mining,
  diamonds: Diamonds,
  renewables: Renewables,
  ecotourism: EcoTourism,
  africa: AfricaOps,
  projects: Projects,
  team: Team,
  partners: Partners,
  news: News,
  gallery: Gallery,
  careers: Careers,
  contact: Contact,
};

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const navigate = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    document.title = 'Varahi Global Consulting';
  }, []);

  const PageComponent = PAGES[currentPage] || Home;

  return (
    <div style={{ paddingTop: '72px' }}>
      <Navbar currentPage={currentPage} onNavigate={navigate} />
      <PageComponent onNavigate={navigate} />
    </div>
  );
}

export default App;
